import { FilterDefinition, Operators } from "@monolith-forensics/monolith-ui";
import { ArtifactsAPI } from "./artifacts.api";
import { GetArtifactsResponse } from "./artifacts.types";

export const ArtifactsFilterDefinition: FilterDefinition = {
  label: "Artifact",
  pluralLabel: "Artifacts",
  dataField: "artifact_id",
  inputType: "multiselect",
  operators: [Operators.In, Operators.NIn],
  query: {
    initialPageParam: 1,
    cacheKey: ({ search }) =>
      JSON.stringify([...ArtifactsAPI.queryKeys.infiniteList()]),
    loadPage: async ({ search }) => {
      const page = (await ArtifactsAPI.get()) as GetArtifactsResponse;

      return {
        items:
          page?.map((artifact) => ({
            label: artifact.artifact,
            value: artifact.artifact_id,
            data: artifact,
          })) || [],
        nextPageParam: null,
      };
    },
  },
};
